import { createAction } from '../../../store.model';
import { ActionType } from '../search.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reset {}

export const reset = createAction<ActionType, Reset>(
    ActionType.EVAL_SEARCH__RESET,
);
